import React, { useEffect } from 'react'
import styled from 'styled-components'
import { usePlans } from 'src/hooks/usePlans'
import { Scroller } from 'src/components/Scroller'
import { Loader } from 'src/ui'

const PriceDetails = {
  developer: [
    'One application included',
    'Unlimited buildings included',
    'Location engagement features',
    '100,000 API requests**',
    'Priority email support - 8 hours',
    '**$25 / extra 10,000 API requests',
    '7 days free trial',
  ],
  explorer: [
    'One application included',
    'One building included',
    '20,000 API requests*',
    'Email support',
    '* $30 / extra 10,000 API requests',
    '7 days free trial',
  ],
  executive: [
    'Unlimited application included',
    'Unlimited buildings included',
    'Location engagement features',
    '500,000 API requests***',
    'Priority email support - 2 hours',
    '*** $15 / extra 10,000 API requests',
    '7 days free trial',
  ],
  enterprise: [
    'All in the Executive Plan',
    'Suitable for big organisations',
    'We handle all project aspects',
    'Dedicated project manager',
    'Scalable service',
    'Priority support, phone & email',
    'Free Pilot Project',
  ],
}

export const Pricing = props => {
  const { get: getPlans, plans, isLoading } = usePlans()

  useEffect(getPlans, [getPlans])
  if (isLoading) {
    return <Loader />
  }

  return (
    <PlansContainer className={props.className}>
      <PlansWrap>
        <Scroller autoHide={false}>
          <Header>Plans</Header>
          <StartFree>Start your free subscription today!</StartFree>
          <WhenYou>
            When you start your first subscription it’ll start with a 7-day free
            trial, which lets you try it for free.
            <br />
            The subscription payment will be taken from your card only at the
            end of the trial period.
          </WhenYou>
          <SubHeader>Find the best fit for your business:</SubHeader>

          <Plans>
            {plans.map(plan => {
              if (/test/.test(plan.slug)) return

              const isEnterprise = /enterprise/.test(plan.slug)

              return (
                <Plan
                  className="plan"
                  key={plan.slug}
                  isEnterprise={isEnterprise}
                >
                  <h2>{plan.name}</h2>
                  {plan.price && (
                    <Price className="price">
                      <small>$</small>
                      {plan.price}
                      <small>/ mo</small>
                    </Price>
                  )}
                  {(isEnterprise || !plan.price) && (
                    <Price className="price">
                      Please contact us for a price quotation
                    </Price>
                  )}

                  <Description>
                    {plan.description}
                    {PriceDetails[plan.slug] && (
                      <List>
                        {PriceDetails[plan.slug].map(item => (
                          <ListItem key={item}>{item}</ListItem>
                        ))}
                      </List>
                    )}
                  </Description>

                  <StartTrial
                    onClick={() => {
                      !isEnterprise
                        ? props.setPlan(plan.slug)
                        : (window.location.href =
                            'https://nearmotion.com/about/#contact-us')
                    }}
                  >
                    {isEnterprise ? 'Contact us' : 'Start free trial'}
                  </StartTrial>
                </Plan>
              )
            })}
          </Plans>
        </Scroller>
      </PlansWrap>
    </PlansContainer>
  )
}

const Header = styled.h1`
  margin-top: 70px;
  font-style: normal;
  font-weight: bold;
  font-size: 48px;
  line-height: 48px;
  text-align: center;
  color: #344356;
  @media (max-width: 1200px) {
    margin-top: 40px;
  }
`
const Plans = styled.div`
  display: flex;
  position: relative;
  flex-wrap: wrap;
  justify-content: center;
  grid-gap: 30px;
  justify-items: center;
  width: 100%;
  padding: 30px 30px 100px;
`

const StartTrial = styled.button`
  display: flex;
  margin: 0 auto;
  margin-top: 55px;
  width: 100%;
  height: 60px;
  justify-content: center;
  align-items: center;
  appearance: none;
  border: none;
  outline: none;
  color: #5468ff;
  font-size: 22px;
  text-align: center;
  background: #eff2fe;
  border-radius: 6px;
  text-decoration: none;
  cursor: pointer;
  @media (max-width: 1024px) {
    margin-top: 15px;
    height: 46px;
    font-size: 18px;
  }
`

const Description = styled.div`
  margin: 24px 0 0;
  min-height: 290px;
  @media (max-width: 1024px) {
    min-height: max-content;
  }
`

const List = styled.ul`
  padding: 0;
  line-height: 47px;
  list-style: none;
`
const Price = styled.div`
  margin-top: 24px;
  font-weight: bold;
  font-size: 48px;
  line-height: 52px;
  color: #344356;

  small {
    font-weight: bold;
    font-size: 18px;
    line-height: 0;
    text-align: center;
    color: #344356;
  }

  ${props =>
    props.isEnterprise &&
    `
    margin-top: 22px;
    font-size: 21px;
    line-height: 21px;
  `}
`

const Plan = styled.div`
  height: 642px;
  margin-top: 20px;
  position: relative;
  padding: 48px 36px 25px 41px;
  max-width: 350px;
  width: 330px;
  background: #ffffff;
  box-shadow: 0 20px 50px rgba(132, 148, 205, 0.08);
  border-radius: 20px;
  &:hover {
    margin-top: 0;
    padding-top: 68px;
    background-image: url("data:image/svg+xml,%3Csvg width='186' height='148' viewBox='0 0 186 148' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M169.333 8.07481C153.129 -1.75896 127.65 -1.74953 111.086 16.298C106.608 21.1768 102.925 25.5911 99.5804 29.5994C97.8671 31.6529 96.2427 33.5998 94.6459 35.448C89.9432 40.8911 85.5049 45.4463 79.8295 49.2007C68.4752 56.7119 52.2608 60.9582 19.2475 62.959C2.93763 63.9474 -7.70883 72.5166 -12.8616 84.6552C-13.6651 86.5481 -14.3354 88.5289 -14.8726 90.5824C-9.06309 83.3807 -0.314537 78.641 11.3845 77.9316C42.7289 76.031 57.9117 72.0015 68.4724 65.0117C73.7545 61.5156 77.9031 57.264 82.3516 52.1126C83.849 50.3786 85.3832 48.5389 87.0065 46.5925C90.1937 42.7709 93.7241 38.5377 97.9926 33.8846C114.095 16.3314 138.834 16.3408 154.565 25.8924C162.44 30.6734 168.109 37.8767 169.278 46.5223C170.447 55.1762 167.091 65.1552 157.16 75.4503C151.137 81.6947 150.645 91.3814 151.531 102.823C151.777 106.013 152.131 109.336 152.494 112.742L152.494 112.744C153.423 121.466 154.411 130.738 153.813 139.754C153.154 149.686 150.572 159.37 143.869 167.795C146.651 166.111 149.13 164.327 151.336 162.457C163.132 152.457 167.183 139.942 168.049 126.894C168.673 117.506 167.648 107.895 166.674 98.7514L166.674 98.7512L166.674 98.7509C166.289 95.1457 165.913 91.6133 165.648 88.1959C164.719 76.1929 165.165 65.547 171.857 58.6126C182.16 47.9375 185.508 37.739 184.331 29.0347C183.153 20.3221 177.426 12.9864 169.333 8.07481ZM-13.7821 84.2645C-14.8974 86.8919 -15.7606 89.6801 -16.3733 92.5907C-17.7788 94.6229 -18.976 96.8195 -19.9652 99.1511C-21.2038 102.07 -22.1154 105.198 -22.7023 108.477C-29.9462 111.998 -35.0925 117.844 -38.1474 125.047C-41.405 132.728 -42.2772 141.93 -40.8146 151.473C-52.9104 153.622 -61.0346 160.869 -65.2022 170.679C-69.8941 181.722 -69.5557 195.966 -64.3447 209.776C-53.9126 237.423 -23.9164 263.448 24.8134 259.002C53.4216 256.391 71.0561 249.679 81.7369 240.632C92.4389 231.568 96.0959 220.215 96.8745 208.497C96.9511 207.344 96.9998 206.187 97.0246 205.027C102.752 202.457 107.432 199.517 111.242 196.285C115.644 192.549 118.874 188.433 121.211 184.064C127.887 181.215 133.269 177.907 137.589 174.243C139.177 172.897 140.619 171.503 141.93 170.068C145.771 167.954 149.102 165.662 151.983 163.22C164.046 152.994 168.169 140.187 169.047 126.96C169.677 117.48 168.638 107.73 167.66 98.5568L167.66 98.5565C167.278 94.9726 166.905 91.4765 166.645 88.1187C165.713 76.0848 166.229 65.8844 172.577 59.3071C183.024 48.4822 186.551 37.9932 185.322 28.9007C184.094 19.8164 178.133 12.2458 169.852 7.21992C153.306 -2.8213 127.285 -2.83072 110.349 15.6218C105.857 20.5157 102.143 24.9674 98.7888 28.9869L98.7883 28.9875L98.7847 28.9918L98.7833 28.9936L98.7798 28.9977C97.0747 31.0411 95.4628 32.9729 93.8892 34.7942C89.2072 40.2133 84.8394 44.6875 79.2777 48.3667C68.1577 55.7229 52.1737 59.9616 19.187 61.9608C2.49682 62.9723 -8.48174 71.7782 -13.7821 84.2645ZM-64.2819 171.07C-60.2485 161.576 -52.4095 154.553 -40.6551 152.46C-39.9578 156.569 -38.8298 160.734 -37.2754 164.861C-36.8897 165.884 -36.4778 166.906 -36.0397 167.924C-36.3939 168.591 -36.721 169.278 -37.0208 169.982C-40.5489 178.267 -40.2904 188.941 -36.3808 199.279C-28.5513 219.982 -6.04354 239.453 30.4921 236.127C51.9197 234.176 65.1507 229.159 73.1747 222.378C77.4752 218.743 80.2618 214.618 82.0135 210.225C87.2463 208.845 91.8925 207.251 96.0139 205.471C95.987 206.46 95.9421 207.447 95.8767 208.431C95.1099 219.97 91.5251 231.031 81.0906 239.869C70.6349 248.725 53.2383 255.404 24.7226 258.006C-23.5532 262.411 -53.1335 236.655 -63.4091 209.423C-68.5521 195.793 -68.8504 181.823 -64.2819 171.07ZM82.4468 209.075C87.5337 207.701 92.0429 206.123 96.0366 204.371C96.0974 200.058 95.8342 195.719 95.4541 191.438C92.0529 192.059 88.4612 192.611 84.6689 193.088C84.6974 194.827 84.6661 196.564 84.5513 198.287C84.3064 201.964 83.6818 205.596 82.4468 209.075ZM83.6718 193.211C83.6964 194.885 83.6643 196.558 83.5535 198.221C83.2982 202.055 82.6248 205.815 81.2669 209.387C73.3678 211.436 64.1119 213.006 53.2776 213.997C6.23894 218.296 -23.3454 194.386 -34.9282 167.973C-31.215 161.294 -24.5888 156.714 -14.9513 156.132C-13.7878 156.062 -12.6558 155.987 -11.5539 155.908C3.61889 179.329 33.1557 197.93 76.5513 193.965C78.999 193.741 81.3718 193.49 83.6718 193.211ZM84.646 192.083C88.4175 191.607 91.9864 191.057 95.3632 190.438C95.1472 188.115 94.9014 185.81 94.659 183.538L94.6587 183.535L94.6585 183.534L94.6272 183.24C92.4038 183.503 90.1162 183.743 87.7628 183.958C86.5385 184.07 85.3246 184.164 84.1213 184.242C84.3674 186.827 84.5696 189.454 84.646 192.083ZM83.1223 184.303C83.3723 186.916 83.5768 189.561 83.6503 192.206C81.33 192.488 78.9342 192.743 76.4603 192.969C33.7322 196.873 4.65008 178.726 -10.4144 155.825C-5.30645 155.438 -0.862816 154.955 3.04123 154.364C19.7356 173.003 46.5262 186.406 83.1223 184.303ZM84.0242 183.247C85.2294 183.169 86.4453 183.074 87.6719 182.962C90.0212 182.747 92.3037 182.508 94.5213 182.245C94.2298 179.5 93.9527 176.805 93.7496 174.186C92.9262 163.563 93.3176 154.114 99.2663 147.956C108.385 138.515 111.341 129.505 110.301 121.823C109.26 114.132 104.2 107.652 97.0412 103.311C82.7054 94.6189 60.1645 94.6284 45.5117 110.58C41.5456 114.898 38.2846 118.803 35.3224 122.35C33.8043 124.168 32.3647 125.892 30.949 127.529C26.7817 132.349 22.8458 136.385 17.8115 139.713C12.8927 142.964 6.9472 145.524 -1.25562 147.499C0.201263 149.475 1.76203 151.41 3.42645 153.293C13.5583 151.713 19.8731 149.395 24.7574 146.174C28.4267 143.754 31.3114 140.81 34.4129 137.231C35.4548 136.029 36.5241 134.751 37.6562 133.399L37.6563 133.398C39.8822 130.739 42.3509 127.79 45.332 124.552C56.6262 112.284 73.9735 112.294 85.0036 118.967C90.5274 122.309 94.5202 127.354 95.3434 133.423C96.1677 139.501 93.7977 146.485 86.8449 153.667C82.6937 157.955 82.3398 164.622 82.9583 172.583C83.1299 174.793 83.3763 177.097 83.6291 179.462L83.6293 179.464L83.6293 179.464C83.7625 180.71 83.8975 181.972 84.0242 183.247ZM4.22157 154.179C14.0737 152.588 20.3751 150.262 25.3079 147.009C29.0909 144.514 32.0462 141.489 35.1685 137.886C36.231 136.66 37.3099 135.371 38.4469 134.012C40.6632 131.364 43.1004 128.452 46.0677 125.229C56.9901 113.365 73.7968 113.356 84.4859 119.823C89.8217 123.051 93.5798 127.861 94.3525 133.557C95.1239 139.246 92.9346 145.939 86.1264 152.971C81.6294 157.616 81.3452 164.73 81.9613 172.661C82.1376 174.93 82.388 177.272 82.6432 179.659C82.7721 180.865 82.9023 182.082 83.0247 183.307C47.0816 185.362 20.7422 172.34 4.22157 154.179ZM2.25182 153.47C0.63105 151.609 -0.890747 149.698 -2.31328 147.747C-5.77943 148.542 -9.63914 149.237 -13.9789 149.842C-13.0697 151.536 -12.0879 153.214 -11.0338 154.868C-5.99081 154.497 -1.60246 154.033 2.25182 153.47ZM-12.1657 154.949C-13.1916 153.315 -14.1482 151.658 -15.0355 149.986C-21.02 150.784 -27.8983 151.416 -35.8857 151.9C-37.1874 151.979 -38.4484 152.112 -39.6687 152.298C-38.9828 156.337 -37.8729 160.437 -36.3395 164.508C-36.0483 165.281 -35.7419 166.053 -35.4202 166.823C-31.4771 160.21 -24.6739 155.718 -15.0116 155.134C-14.0409 155.075 -13.0925 155.014 -12.1657 154.949ZM-35.5194 169.104C-23.5461 195.61 6.32352 219.293 53.3687 214.992C63.9154 214.028 72.995 212.515 80.8025 210.538C79.0913 214.542 76.463 218.29 72.5292 221.614C64.7303 228.205 51.7369 233.189 30.4014 235.131C-5.68171 238.416 -27.7731 219.212 -35.4455 198.925C-39.2868 188.768 -39.505 178.368 -36.1007 170.374C-35.9175 169.943 -35.7237 169.52 -35.5194 169.104ZM110.595 195.522C106.959 198.607 102.498 201.433 97.0412 203.921C97.0777 199.693 96.814 195.44 96.4416 191.254C105.514 189.541 113.209 187.322 119.724 184.683C117.496 188.546 114.523 192.189 110.595 195.522ZM120.494 183.282C113.838 186.09 105.871 188.451 96.3505 190.254C96.1333 187.92 95.887 185.611 95.6449 183.342L95.6449 183.341L95.6213 183.12C106.087 181.836 115.113 180.017 122.889 177.747C122.23 179.63 121.438 181.478 120.494 183.282ZM123.276 176.59C115.42 178.932 106.237 180.809 95.5154 182.126C95.2237 179.379 94.9473 176.697 94.7466 174.108C93.9208 163.455 94.3818 154.452 99.9856 148.65C109.249 139.06 112.384 129.759 111.292 121.688C110.201 113.626 104.907 106.912 97.5596 102.456C82.8824 93.5567 59.7998 93.5472 44.7752 109.903C40.7953 114.236 37.5028 118.179 34.531 121.737C33.0179 123.549 31.5878 125.262 30.1925 126.875C26.046 131.67 22.1807 135.626 17.2601 138.878C12.3766 142.106 6.4313 144.656 -1.89258 146.622C-6.14801 140.688 -9.47837 134.397 -11.8774 128.033C-14.5132 121.042 -16.0231 113.971 -16.4038 107.194C-13.9142 106.52 -11.2292 106.082 -8.3475 105.908C21.3903 104.104 36.0068 100.275 46.2457 93.4958C51.3635 90.1072 55.3647 85.9965 59.6016 81.0882C61.0388 79.4233 62.5002 77.6703 64.0412 75.8218L64.0438 75.8186L64.0459 75.8161L64.0481 75.8135L64.0482 75.8133C67.0601 72.2003 70.376 68.2225 74.4086 63.8249C89.3101 47.5744 112.233 47.5651 126.812 56.4202C134.092 60.8425 139.239 67.4443 140.298 75.2809C141.355 83.1092 138.349 92.2894 129.076 101.906C123.031 108.175 122.632 117.795 123.469 128.614C123.708 131.698 124.047 134.885 124.393 138.136V138.136L124.393 138.136C125.271 146.378 126.193 155.036 125.632 163.495C125.336 167.963 124.625 172.36 123.276 176.59ZM-12.8131 128.386C-10.4285 134.711 -7.13737 140.961 -2.94742 146.866C-6.36959 147.635 -10.1839 148.312 -14.4756 148.901C-15.8673 146.219 -17.0787 143.498 -18.1091 140.764C-22.1982 129.912 -23.4341 118.858 -21.8052 109.157C-20.412 108.507 -18.9401 107.945 -17.389 107.476C-16.9811 114.297 -15.4508 121.39 -12.8131 128.386ZM-19.0449 141.116C-18.0413 143.78 -16.8688 146.429 -15.528 149.042C-21.3929 149.814 -28.1303 150.429 -35.9461 150.902C-37.2812 150.983 -38.5752 151.12 -39.828 151.31C-41.2642 141.928 -40.3996 132.919 -37.2268 125.437C-34.3581 118.674 -29.5966 113.141 -22.9046 109.696C-24.393 119.428 -23.0857 130.393 -19.0449 141.116ZM121.927 182.661C128.01 179.959 132.948 176.868 136.942 173.48C137.686 172.85 138.397 172.209 139.076 171.558C134.7 173.727 129.722 175.684 124.064 177.397C123.472 179.183 122.765 180.94 121.927 182.661ZM124.432 176.239C130.949 174.225 136.53 171.883 141.302 169.272C149.181 160.575 152.11 150.318 152.815 139.687C153.407 130.764 152.434 121.63 151.508 112.938L151.508 112.938C151.143 109.51 150.785 106.151 150.533 102.9C149.65 91.4895 150.073 81.3575 156.441 74.756C166.227 64.6108 169.404 54.922 168.287 46.6562C167.169 38.3821 161.732 31.4138 154.046 26.7471C138.657 17.4033 114.46 17.4127 98.7295 34.5606C94.4751 39.1983 90.9762 43.394 87.7987 47.2043L87.7983 47.2048L87.7977 47.2055L87.7941 47.2099L87.7937 47.2104L87.7913 47.2132C86.1656 49.1625 84.6241 51.011 83.1084 52.7662C78.6393 57.9416 74.4201 62.2743 69.0243 65.8456C58.2293 72.9904 42.816 77.0276 11.445 78.9298C-0.911659 79.6791 -9.84401 85.012 -15.4355 92.9937C-16.2951 97.1637 -16.6338 101.596 -16.4527 106.172C-13.958 105.513 -11.2765 105.083 -8.40805 104.909C21.3031 103.107 35.6891 99.2862 45.6937 92.662C50.6977 89.3487 54.6284 85.3191 58.8447 80.4348C60.2633 78.7913 61.7172 77.0474 63.2555 75.2021L63.2562 75.2013C66.2777 71.577 69.625 67.5618 73.6716 63.149C88.9448 46.4932 112.41 46.5026 127.331 55.5655C134.8 60.1023 140.18 66.939 141.289 75.147C142.399 83.3632 139.213 92.8336 129.796 102.6C124.095 108.512 123.627 117.686 124.466 128.537C124.7 131.561 125.036 134.711 125.38 137.941C126.26 146.213 127.197 155.01 126.63 163.561C126.344 167.866 125.678 172.123 124.432 176.239ZM-17.4421 106.449C-17.6102 102.576 -17.4131 98.7987 -16.8481 95.1847C-17.6704 96.5729 -18.4025 98.028 -19.0447 99.5417C-20.1653 102.183 -21.0131 105.005 -21.5885 107.961C-20.2718 107.381 -18.8897 106.875 -17.4421 106.449Z' fill='%23545981'/%3E%3C/svg%3E");
    background-color: #172647;
    background-repeat: no-repeat;
    background-position: bottom left;
    color: #ffffff;
    ${StartTrial} {
      background: #5468ff;
      color: white;
    }
    ${Price} {
      color: white;
      small {
        color: white;
      }
    }
  }

  &:hover:before,
  &:hover:after {
    position: absolute;
    content: '';
  }

  &:hover:after {
    top: 35px;
    right: 35px;
    height: 9px;
    width: 13px;
    border-left: 3px solid white;
    border-bottom: 3px solid white;
    transform: rotate(-45deg);
  }

  &:hover:before {
    top: 20px;
    right: 20px;
    width: 44px;
    height: 44px;
    background: #00d9fc;
    border-radius: 50%;
    border: 6px solid #5d677e;
  }
  h2 {
    margin: 0;
  }

  ${props =>
    props.isEnterprise &&
    `
    ${List} {
      margin-top: 20px;
    }
    ${Price}{
      line-height: 28px;
      font-size: 18px;
    }
  `}
`

const ListItem = styled.li`
  position: relative;
  padding-left: 25px;

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 15px;
    left: 0;
    height: 5px;
    width: 10px;
    border-left: 1px solid #5468ff;
    border-bottom: 1px solid #5468ff;
    transform: rotate(-45deg);
  }

  &:before {
    border-color: #00d9fc;
  }
`

const SubHeader = styled.div`
  margin: 0 auto;
  margin-top: 20px;
  max-width: 826px;
  font-style: normal;
  font-weight: normal;
  font-size: 25px;
  line-height: 40px;
  text-align: center;
  color: #9aaccf;
  @media (max-width: 768px) {
    padding: 0 24px;
  }
`

const StartFree = styled(SubHeader)`
  margin-top: 20px;
  color: #344356;
`
const WhenYou = styled(SubHeader)`
  margin-top: 0;
  font-size: 18px;
  line-height: 24px;
`

const PlansWrap = styled.div`
  height: calc(100vh - 72px);
`

const PlansContainer = styled.div`
  font-family: Biko;

  @media (max-width: 1400px) {
    .price {
      margin-top: 30px;
    }

    .enterprise .price {
      margin-top: 22px;
      line-height: 28px;
    }

    .plan,
    .plan.selected {
      height: auto;
      padding-top: 48px;
      margin: 0;
    }
  }

  @media (max-width: 1200px) {
    .common-content {
      padding-top: 100px;
    }

    .price {
      margin-top: 30px;
    }

    .plan ul {
      margin-top: 20px;
      line-height: 35px;
    }

    .plan {
      margin: 0;
      padding-top: 48px;
    }
  }

  @media (max-width: 1024px) {
    .plan {
      padding: 30px 30px;
    }

    .plan ul {
      margin-top: 10px;
      line-height: 30px;
    }

    .price {
      font-size: 30px;
      margin-top: 15px;
    }

    .enterprise .price {
      height: 60px;
      font-size: 21px;
      line-height: 21px;
    }

    .enterprise ul {
      margin: 0;
    }
  }

  @media (max-width: 768px) {
    .price {
      font-size: 20px;
    }
  }

  @media (max-width: 536px) {
    .price {
      margin-top: 10px;
      font-size: 20px;
    }
  }
`
